'use strict';

var AlarmController = require('components/devices/controllers/alarm');
var AlarmOccurrenceController = require('components/devices/controllers/alarm_occurrence');
var AnalyzeView = require('components/devices/views/common/analyze_view');
var App = require('app');
var AppState = require('app_state');
var BaseController = require('components/devices/controllers/base_controller');
var BreadcrumbView = require('components/common/views/breadcrumb_view');
var Charts = require('components/devices/controllers/charts');
var CommonViews = require('components/common/views');
var ConfigurationView = require('components/devices/views/common/configuration_view');
var ConfigureUserDialogView = require('components/common/views/configure_user_dialog_view');
var ConfigureValueDialogView = require('components/common/views/configure_value_dialog_view');
var Consts = require('consts');
var ControllerBackupDialogView = require('components/devices/views/controller/backup_dialog_view');
var DataEditDialogView = require('components/devices/views/common/data_edit_dialog_view');
var DataView = require('components/devices/views/common/data_view');
var Decorator = require('utils/decoration');
var DeviceActionController = require('components/devices/controllers/device_action_controller');
var DeviceController = require('components/devices/devices_controller');
var EditValueView = require('components/devices/views/common/edit_value_view');
var EventLogView = require('components/devices/views/common/event_log');
var FirmwareConfigView = require('components/devices/views/gateway/firmware_config_view');
var GatewayDashboard = require('components/devices/views/gateway/gateway_dashboard');
var GroupingDialogView = require('components/common/views/grouping_dialog_view');
var ContractDialogView = require('components/common/views/contract_dialog_view');
var HandlingSettingsView = require('components/devices/views/controller/handling_settings_view');
var HandlingView = require('components/devices/views/controller/handling_view');
var HomeController = require('components/home/home_controller');
var i18n = require('utils/i18n');
var InfoManagementDialogView = require('components/devices/views/common/info_management_dialog_view');
var InfoManagementView = require('components/devices/views/common/info_management_view');
var InfoView = require('components/devices/views/common/info_view');
var MeterView = require('components/devices/views/meter/meter_view');
var Misc = require('utils/misc');
var ModbusView = require('components/devices/views/controller/modbus_view');
var Notification = require('utils/notification');
var OnsiteAccessWizardView = require('components/devices/views/gateway/onsite_access_wizard_view');
var OverviewView = require('components/devices/views/gateway/overview_view');
var ParameterView = require('components/devices/views/controller/parameter_view');
var Permissions = require('models/permissions');
var RemoteControlView = require('components/devices/views/controller/remote_control_view');
var Requests = require('utils/requests');
var SchemeLayoutView = require('components/scheme/views/layout_view');
var SelectValuesDialogView = require('components/common/views/select_values_dialog_view').Dialog;
var SelectHCsDialogView = require('components/scheme/views/select_hcs_dialog_view');
var SmartTemp = require('models/smart_temp');
var SmartTempDialogView = require('components/devices/views/controller/smart_temp_dialog_view');
var SubDeviceListView = require('components/devices/views/common/subdevice_list_view');
var UserAdminView = require('components/devices/views/common/user_admin_view');
var UserTransferDialogView = require('components/devices/views/common/user_transfer_dialog_view');
var Utils = require('components/common/utils');
var Values = require('models/values');
var ValueSelectDialog = require('components/devices/views/common/value_selection_dialog_view');

function getTabName(name) {
    return name == 'analyze-predefined' ? 'analyze' : name;
}

var BaseDeviceController = BaseController.extend({
    // To implement/define in sub-class:
    // - getDeviceListView(deviceList)
    // - getBreadcrumbsView(device)

    analyze: new Charts(),
    itemsPerPage: 20,

    getDeviceListView: function (deviceList, count, listResult, itemsPerPage, hasFilter) {
        if (deviceList.length == 0) {
            if (hasFilter) {
                var options = {
                    title: i18n.TR('Keine Geräte gefunden'),
                    text: i18n.TR('Es wurden keine Geräte gefunden, die Ihrer Filtereinstellung entsprechen.'),
                    action_label: i18n.TR('Filter zurücksetzen'),
                    action_cb: function () {
                        AppState.setURLParameter({ filter: '{}' }, 'update');
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    },
                };
                return new CommonViews.Message(options);
            } else {
                // no devices returned -> show placeholder
                options = $.extend(options, Consts.DeviceCategory[this.deviceCategory].noData);
                return new CommonViews.Message(options);
            }
        } else {
            var lv = this.listView;
            return new lv({
                deviceCategory: this.deviceCategory,
                controller: this,
                collection: deviceList,
                itemCount: count,
                listResult: listResult,
                itemsPerPage: itemsPerPage,
            });
        }
    },

    getBreadcrumbsView: function (device, tab) {
        var categoryData = Consts.DeviceCategory[this.deviceCategory];
        var data = {
            base: {
                link: categoryData.url,
                title: categoryData.listTitle,
            },
            target: {
                link: tab,
            },
            id: device.id,
            device: device,
        };
        return new BreadcrumbView(data);
    },

    setItemsPerPage: function (itemsPerPage) {
        AppState.saveItemsPerPage(itemsPerPage);
    },

    initialize: function (options) {
        options = options || {};
        this.deviceCategory = options.deviceCategory || this.deviceCategory;
        this.listView = this.listView || App.DevicesCategoryObj[this.deviceCategory].listView;
    },

    showDevice: function (id, tab, parameter1) {
        var self = this;
        this.analyze.id = id;

        HomeController.showBaseLayout({
            deviceID: id,
            cb: function (permissions) {
                var contentView;

                AppState.layout.breadcrumbs.reset();

                if (!id) {
                    self.itemsPerPage = AppState.getItemsPerPage();
                    // initialize default sidebar
                    App.trigger('sidebar:default', self.deviceCategory);

                    // fetch device list
                    var filterParams = $.extend(
                        { limit: self.itemsPerPage },
                        AppState.getURLParameter(['sortCol', 'sortDesc', 'page', 'filter'])
                    );

                    if (filterParams.filter) {
                        filterParams.filter = JSON.parse(filterParams.filter);
                    }

                    var deviceList = App.request(self.deviceCategory + ':list', filterParams);

                    $.when(deviceList).done(function (deviceList) {
                        if (deviceList === undefined) {
                            contentView = new CommonViews.Message({
                                title: i18n.TR('Fehler'),
                                text: i18n.TR('Die Geräteliste konnte nicht geladen werden.'),
                                color_class: 'box-color-error',
                                action_label: i18n.TR('Zurück zur Übersicht'),
                                action_cb: function () {
                                    // TODO
                                },
                            });
                        } else {
                            contentView = self.getDeviceListView(
                                deviceList.items,
                                deviceList.count,
                                deviceList.listResult,
                                self.itemsPerPage,
                                Misc.hasFilterSet(filterParams.filter, { category: true })
                            );
                        }
                        App.showContentView(contentView);
                    });
                } else {
                    // no tab given? -> determine default (= based on "first" permission)
                    if (tab === null || tab === undefined) {
                        tab = Consts.PermissionsToRoute[permissions.sorted()[0]] || 'info';
                        // TODO: check with SAM LAN Gateways!
                        App.navigate(Consts.DeviceCategory[self.deviceCategory].url + '/' + id + '/' + tab, {
                            replace: true,
                        });
                        AppState.layout.updateHelpIcon();
                    }

                    var device = App.request('device:model', id);
                    $.when(device).done(function (device) {
                        if (device === undefined || !device.isCategory(self.deviceCategory)) {
                            // could not load device
                            contentView = new CommonViews.Message({
                                title: i18n.TR('Fehler'),
                                text: i18n.TR('Das gesuchte Gerät konnte nicht gefunden werden.'),
                                color_class: 'box-color-error',
                                action_label: i18n.TR('Zurück zur Übersicht'),
                                action_cb: function () {
                                    App.trigger(self.deviceCategory + ':show');
                                },
                            });
                        } else {
                            // device fetched successfully
                            // show 'tab' for requested device 'id'
                            App.trigger(
                                'sidebar:' + self.deviceCategory,
                                id,
                                permissions,
                                getTabName(tab),
                                device.getCircuitNames()
                            );

                            var breadcrumbsView = self.getBreadcrumbsView(device, tab);
                            var accessRight, circuitName;
                            switch (tab) {
                                case 'control-remote':
                                    breadcrumbsView.options.target = {
                                        link: 'control-remote',
                                        title: i18n.TR('Fernbedienung'),
                                    };

                                    AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                    contentView = new RemoteControlView({
                                        category: self.deviceCategory,
                                        model: device,
                                        controller: self,
                                    });
                                    App.showContentView(contentView, permissions);
                                    return;
                                case 'alarm-configuration':
                                    breadcrumbsView.options.target = {
                                        link: 'alarm-configuration',
                                        title: i18n.TR('Alarmkonfiguration'),
                                    };

                                    var c = new AlarmController();
                                    c.show(
                                        parameter1,
                                        id,
                                        breadcrumbsView,
                                        {
                                            req: 'sidebar:' + self.deviceCategory,
                                            selected: id,
                                            permissions: permissions,
                                            tab: tab,
                                            circuitNames: device.getCircuitNames(),
                                        },
                                        device
                                    );
                                    return;
                                case 'alarm-list':
                                    breadcrumbsView.options.target = {
                                        link: 'alarm-list',
                                        title: i18n.TR('Alarmmeldungen'),
                                    };

                                    var c = new AlarmOccurrenceController();
                                    c.show(id, breadcrumbsView, {
                                        req: 'sidebar:' + self.deviceCategory,
                                        selected: id,
                                        permissions: permissions,
                                        tab: tab,
                                        circuitNames: device.getCircuitNames(),
                                    });
                                    return;

                                case 'analyze-predefined':
                                case 'analyze':
                                    breadcrumbsView.options.target = {
                                        link: 'analyze',
                                        title: i18n.TR('Analyse'),
                                    };

                                    var urlHash = window.location.hash;
                                    urlHash = urlHash.split('?')[0];
                                    urlHash = urlHash.split('/');
                                    var urlPeriod =
                                        urlHash.length >= 2 && urlHash[urlHash.length - 2] == 'analyze'
                                            ? urlHash[urlHash.length - 1]
                                            : 'today';
                                    var companyFeatures = App.request('company:features');
                                    var bookmarks = App.request('bookmarks:get', 'charts', undefined);

                                    $.when(companyFeatures, bookmarks).done(function (companyFeatures, bookmarks) {
                                        self.analyze.init(
                                            device,
                                            self,
                                            self.deviceCategory,
                                            function () {
                                                contentView = new AnalyzeView(
                                                    {
                                                        category: self.deviceCategory,
                                                        model: device,
                                                        controller: self,
                                                        bookmarks: bookmarks,
                                                    },
                                                    urlPeriod
                                                );

                                                App.showContentView(contentView, permissions);
                                                self.analyze.useView(contentView);
                                                AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                            },
                                            parameter1,
                                            tab == 'analyze-predefined'
                                        );
                                    });
                                    return;
                                case 'modbus':
                                    breadcrumbsView.options.target = {
                                        link: 'modbus',
                                        title: i18n.TR('Modbus'),
                                    };
                                    breadcrumbsView.options.devices = [{ id: id, name: device.get('name') }];
                                    contentView = new ModbusView({
                                        model: device,
                                    });
                                    break;
                                case 'status-schema':
                                    breadcrumbsView.options.target.title = i18n.TR('Anlagenschema');
                                    if (device.attributes.category.startsWith('Gateway')) {
                                        // get connected controller
                                        var controllerList = App.request('device:list', {
                                            filterParams: { parentID: device.id, category: ['55xx56xx'] },
                                        });
                                        // has own schema?
                                        var hasOwnSchema = App.request('schema:has_own', device.id);

                                        // show schema view
                                        $.when(controllerList, hasOwnSchema).done(function (ctrList, hasOwnSchema) {
                                            contentView = new GatewayDashboard({
                                                controllerList: ctrList,
                                                controller: self,
                                                gateway: device,
                                                hasOwnSchema: hasOwnSchema,
                                            });

                                            AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                            App.showContentView(contentView, permissions);
                                        });
                                        return;
                                    }

                                    var schemaJSON = App.request('schema:additional', device.id);
                                    // 1000: Schema-request for circuits 1-3
                                    // 1110: Schema-request for circuit 11
                                    // 1120: Schema-request for circuit 12
                                    // 1130: Schema-request for circuit 13
                                    // the number corresponds to a scheme request which is used for the active tab
                                    // (default tab to be loaded on reload)
                                    var schema = $.Deferred();
                                    if (device.attributes.category === '55xx56xx') {
                                        schema = App.request('circuit:model', device.id, 0, 'schema');
                                    } else {
                                        schema.resolve(undefined);
                                    }
                                    var sensorValues = App.request('device:sensors', device.id);
                                    var inconsistent = App.request('device:inconsistent', device);
                                    var valueList = App.request('device:values', id);
                                    var sidebarConfig = App.request('device:scheme-config', [device.id]);
                                    var hcsConfigReq = App.request('device:hcs-config', device.id);
                                    var smartTempInfoReq = App.request('device:smarttemp', device.id, true);

                                    $.when(
                                        schema,
                                        sensorValues,
                                        inconsistent,
                                        schemaJSON,
                                        valueList,
                                        sidebarConfig,
                                        smartTempInfoReq,
                                        hcsConfigReq
                                    ).done(
                                        function (
                                            schema,
                                            sensorValues,
                                            inconsistent,
                                            schemaJSON,
                                            valueList,
                                            sidebarConfig,
                                            smartTempInfo,
                                            hcsConfig
                                        ) {
                                            if (
                                                (schema === undefined && device.attributes.category === '55xx56xx') ||
                                                sensorValues === undefined
                                            ) {
                                                // could not load schema
                                                contentView = new CommonViews.Message({
                                                    title: i18n.TR('Fehler'),
                                                    text: i18n.TR('Anlagenschemadaten konnten nicht geladen werden.'),
                                                    color_class: 'box-color-error',
                                                    action_label: i18n.TR('Zurück zur Geräteinfo'),

                                                    action_cb: function () {
                                                        App.trigger(self.deviceCategory + ':show', id);
                                                    },
                                                });
                                            } else {
                                                var tabs = self.initTabs(
                                                    device,
                                                    permissions,
                                                    device.attributes.trovis_io_infos,
                                                    !$.isEmptyObject(schemaJSON) ? schemaJSON : undefined
                                                );

                                                var activeTab = 0;
                                                if (tabs.length > 1) {
                                                    var parameter = new URLSearchParams(
                                                        window.location.href.split('?')[1]
                                                    );
                                                    activeTab = parseInt(parameter.get('tab'));
                                                    if (isNaN(activeTab) || activeTab > tabs.length - 1) {
                                                        activeTab = 0;
                                                    }
                                                }

                                                contentView = new SchemeLayoutView({
                                                    model: device,
                                                    schema: schema,
                                                    inconsistent: inconsistent,
                                                    sensorValues: sensorValues,
                                                    columns: AppState.availableColumns(),
                                                    controller: self,
                                                    permissions: permissions,
                                                    tabs: tabs,
                                                    activeTab: activeTab,
                                                    valueList: valueList,
                                                    sidebarConfig: sidebarConfig,
                                                    smartTempInfo: smartTempInfo,
                                                    hcsConfig: hcsConfig,
                                                });
                                            }
                                            AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                            App.showContentView(contentView, permissions);
                                        }
                                    );

                                    return;
                                case 'overview':
                                    breadcrumbsView.options.target = {
                                        link: 'overview',
                                        title: i18n.TR('Gesamtübersicht'),
                                    };

                                    breadcrumbsView.options.actions = [
                                        {
                                            icon: 'fa fa-refresh',
                                            action: function (e) {
                                                contentView.reload();
                                            },
                                            show_me: true,
                                        },
                                        {
                                            icon: 'fa fa-cog',
                                            action: function (e) {
                                                contentView.configure();
                                            },
                                            show_me: AppState.isUserAdmin(),
                                        },
                                    ];

                                    contentView = new OverviewView({
                                        model: device,
                                        controller: self,
                                    });

                                    App.showContentView(contentView, permissions);
                                    AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                    return;

                                case 'status-data':
                                    var valueList = App.request('device:values', id);
                                    var inconsistent = App.request('device:inconsistent', device);

                                    var smartTempInfoReq =
                                        device.get('category') === Consts.Category.Controller
                                            ? App.request('device:smarttemp', id, true)
                                            : $.Deferred().resolve(new SmartTemp.SmartTempInfo()); // don't send request to backend

                                    $.when(valueList, inconsistent, smartTempInfoReq).done(
                                        function (valueList, inconsistent, smartTempInfo) {
                                            breadcrumbsView.options.target.title = i18n.TR('Aktuelle Daten');
                                            if (valueList === undefined) {
                                                // could not load value list
                                                contentView = new CommonViews.Message({
                                                    title: i18n.TR('Fehler'),
                                                    text: i18n.TR('Es konnten keine Werte gefunden werden.'),
                                                    color_class: 'box-color-error',
                                                    action_label: i18n.TR('Zurück zur Geräteinfo'),

                                                    action_cb: function () {
                                                        App.trigger(self.deviceCategory + ':show', id);
                                                    },
                                                });
                                            } else {
                                                // show data list view
                                                contentView = new DataView({
                                                    device: device,
                                                    collection: valueList,
                                                    inconsistent: inconsistent,
                                                    category: self.deviceCategory,
                                                    controller: self,
                                                    smartTempInfo: smartTempInfo,
                                                });
                                            }

                                            var canEditValues =
                                                AppState.hasDevicePermission(
                                                    Consts.Permissions.StateData,
                                                    permissions.attributes
                                                ) === false;
                                            breadcrumbsView.options.actions = [
                                                {
                                                    icon: 'fa fa-gear',
                                                    menu_items: [
                                                        {
                                                            icon: 'fa fa-pencil',
                                                            name: i18n.TR('Wert schreiben'),
                                                            show_me: canEditValues,

                                                            action: function () {
                                                                App.showModal(
                                                                    new EditValueView({
                                                                        deviceID: id,
                                                                        controller: self,
                                                                        category: device.attributes.category,
                                                                        type: device.attributes.type,
                                                                    })
                                                                );
                                                            },
                                                        },
                                                    ],
                                                    show_me: canEditValues,
                                                },
                                            ];

                                            AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                            App.showContentView(contentView, permissions);
                                        }
                                    );
                                    return;
                                case 'status-log':
                                    breadcrumbsView.options.target = {
                                        link: 'status-log',
                                        title: i18n.TR('Ereignisse'),
                                    };
                                    contentView = new EventLogView({
                                        category: self.deviceCategory,
                                        model: device,
                                        controller: self,
                                        eventLog: App.request(
                                            'device:eventlog',
                                            { timeFrom: moment().subtract(1, 'day') },
                                            id
                                        ),
                                    });

                                    App.showContentView(contentView, permissions);
                                    AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                    return;
                                case 'meter':
                                    var valueList = App.request('device:values', id);
                                    $.when(valueList).done(function (valueList) {
                                        breadcrumbsView.options.target.title = i18n.TR('Zählerstand');
                                        if (valueList === undefined) {
                                            // could not load value list
                                            contentView = new CommonViews.Message({
                                                title: i18n.TR('Fehler'),
                                                text: i18n.TR('Zählerwerte konnten nicht geladen werden.'),
                                                color_class: 'box-color-error',
                                                action_label: i18n.TR('Zurück zur Geräteinfo'),
                                                action_cb: function () {
                                                    App.trigger(self.deviceCategory + ':show', id);
                                                },
                                            });
                                        } else {
                                            // show meter values dashboard
                                            contentView = new MeterView({
                                                category: self.deviceCategory,
                                                model: device,
                                                values: valueList,
                                                controller: self,
                                            });
                                            breadcrumbsView.options.actions = [
                                                {
                                                    icon: 'fa fa-plus',
                                                    action: function () {
                                                        contentView.addTile();
                                                    },
                                                    show_me:
                                                        undefined !==
                                                        AppState.hasDevicePermission(
                                                            Consts.Permissions.MeterReadings,
                                                            permissions.attributes
                                                        ),
                                                },
                                            ];
                                        }
                                        AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                        App.showContentView(contentView, permissions);
                                    });
                                    return;
                                case 'info':
                                    var showInfoView = function () {
                                        var canSeeSimInfo =
                                            self.deviceCategory === 'Gateway' && AppState.hasCompanyDevicePermission();

                                        breadcrumbsView.options.target.title = i18n.TR('Gerät');
                                        contentView = new InfoView({
                                            deviceCategory: self.deviceCategory,
                                            model: device,
                                            controller: self,
                                            eventLog: App.request(
                                                'device:eventlog',
                                                { timeFrom: moment().subtract(30, 'day'), itemCount: 5 },
                                                id
                                            ),
                                            simInfo: canSeeSimInfo ? device.getSimInfo('short') : undefined,
                                        });

                                        var archived = device.get('status') === Consts.DeviceStatus.Archived;
                                        var canResetDevice =
                                            (device.attributes.category == 'Gateway' ||
                                                device.attributes.category == '55xx56xx') &&
                                            AppState.hasDevicePermission(
                                                Consts.Permissions.Info,
                                                permissions.attributes
                                            ) === false &&
                                            !archived &&
                                            !device.isExternalDevice();
                                        var canBeArchived =
                                            (device.attributes.category == 'Gateway' ||
                                                device.attributes.category == 'Gateway-RF') &&
                                            !AppState.hasDevicePermission(
                                                Consts.Permissions.Info,
                                                permissions.attributes
                                            ) &&
                                            !archived;
                                        var canLocateOnMap = device.attributes.location != '';
                                        var canPutDeviceToSleep =
                                            AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices) &&
                                            !archived &&
                                            !(
                                                device.get('type') == '5016_pn' &&
                                                device.get('station') < 1 &&
                                                device.get('children') === 0
                                            );
                                        var deviceIsSleeping = device.get('status') === Consts.DeviceStatus.Deactivated;
                                        var deviceLocked = AppState.deviceIsLocked(device.get('id'));
                                        var canAlterLockState = AppState.canUnlockDevice(device.get('id')) && !archived;
                                        var canUpdateDevice =
                                            device.isFirmwareUpdatePossible() && AppState.hasCompanyDevicePermission();

                                        var hasAnyMenuOption =
                                            canResetDevice || canLocateOnMap || canPutDeviceToSleep || canUpdateDevice;
                                        breadcrumbsView.options.actions = [
                                            {
                                                icon: 'fa fa-gear',
                                                menu_items: [
                                                    {
                                                        icon: 'fa fa-upload',
                                                        name: i18n.TR('Firmware Update'),
                                                        show_me: canUpdateDevice,
                                                        action: function () {
                                                            var siblingDeviceInfoReq =
                                                                device.id != device.get('wired_to') &&
                                                                device.get('firmware') < '3.05'
                                                                    ? App.request(
                                                                          'device:name:list',
                                                                          {
                                                                              name: '',
                                                                              parent: device.get('parent'),
                                                                              categories: ['55xx56xx'],
                                                                          },
                                                                          0,
                                                                          2
                                                                      )
                                                                    : $.Deferred().resolve({ items: [] }).promise();

                                                            $.when(siblingDeviceInfoReq).done(function (siblings) {
                                                                Utils.showConfirmationDialog({
                                                                    title: i18n.TR('Firmware Update einplanen'),
                                                                    hint:
                                                                        Consts.DeviceUpdateHint +
                                                                        (siblings.items.length > 1
                                                                            ? '<div class="alert alert-info m-t-20"><b>' +
                                                                              i18n.TR(
                                                                                  'Bei der aktuellen Firmware-Version sollte während des Updates keine weitere Kommunikation auf dem Feldbus getätigt werden um ein erfolgreiches Update zu garantieren. Daher ist entweder ein Update vor-Ort oder ein kurzzeitge Stillegung der restlichen Busteilnehmer nötig. Kann mit Funktions-Labels gelöst werden.'
                                                                              ) +
                                                                              '</b></div>'
                                                                            : '') +
                                                                        '<div class="alert alert-danger m-t-20"><b>' +
                                                                        i18n.TR(
                                                                            'Es wird ein Geräte-Update eingeplant, das sobald wie möglich ausgeführt wird. Diese Aktion kann nicht rückgängig gemacht werden!'
                                                                        ) +
                                                                        '</b></div>',
                                                                    action_label: i18n.TR('Ausführen'),
                                                                    checkboxMap: {
                                                                        wants_email: {
                                                                            label: i18n.TR(
                                                                                'Benachrichtigung per E-Mail wenn Update abgeschlossen.'
                                                                            ),
                                                                        },
                                                                    },
                                                                    cancel_label: i18n.TR('Abbrechen'),
                                                                    action_cb: function (checkboxValues) {
                                                                        App.ajax({
                                                                            url:
                                                                                '/api/v1/devices/' +
                                                                                device.id +
                                                                                '/firmware',
                                                                            type: 'POST',
                                                                            data: JSON.stringify(checkboxValues),
                                                                            success: function () {
                                                                                Notification.show(
                                                                                    'success',
                                                                                    i18n.TR('Erfolg'),
                                                                                    i18n.TR(
                                                                                        'Geräte-Update erfolgreich eingeplant.'
                                                                                    )
                                                                                );

                                                                                // reload current route
                                                                                Backbone.history.loadUrl(
                                                                                    Backbone.history.fragment
                                                                                );
                                                                            },
                                                                            error: function (xhr) {
                                                                                Notification.show(
                                                                                    'error',
                                                                                    i18n.TR('Fehler'),
                                                                                    i18n.TR(
                                                                                        'Geräte-Update konnte nicht eingeplant werden.'
                                                                                    )
                                                                                );
                                                                            },
                                                                        });
                                                                    },
                                                                });
                                                            });
                                                        },
                                                    },
                                                    {
                                                        icon: 'fa fa-repeat',
                                                        name: i18n.TR('Gerät neustarten'),
                                                        show_me: canResetDevice,
                                                        action: function () {
                                                            switch (device.attributes.category) {
                                                                case 'Gateway':
                                                                case '55xx56xx':
                                                                    var actionController = new DeviceActionController();
                                                                    actionController.doReset(id);
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        },
                                                    },
                                                    {
                                                        icon: 'fa fa-map',
                                                        name: i18n.TR('Auf Karte zeigen'),
                                                        show_me: canLocateOnMap,
                                                        action: function () {
                                                            App.trigger('device:map', {
                                                                id: device.id,
                                                                location: device.attributes.location,
                                                            });
                                                        },
                                                    },
                                                    {
                                                        icon: 'fa fa-power-off disabled',
                                                        color: deviceIsSleeping ? '#CCCCCC' : 'black',
                                                        name: deviceIsSleeping
                                                            ? i18n.TR('Gerät aktivieren')
                                                            : i18n.TR('Gerät deaktivieren'),
                                                        show_me: canPutDeviceToSleep,
                                                        action: function () {
                                                            App.request(
                                                                'device:status:set',
                                                                deviceIsSleeping ? 0 : -3,
                                                                device.get('id')
                                                            );
                                                        },
                                                    },
                                                    {
                                                        icon: deviceLocked ? 'fa fa-unlock' : 'fa fa-lock',
                                                        color: 'black',
                                                        name: deviceLocked
                                                            ? i18n.TR('Gerät entsperren')
                                                            : i18n.TR('Gerät sperren'),
                                                        show_me: canAlterLockState,
                                                        key: 'lock',
                                                        action: function (view) {
                                                            var actionController = new DeviceActionController();
                                                            actionController.setDeviceLockStatus(device.id, view);
                                                        },
                                                    },
                                                    {
                                                        icon: 'fa fa-archive',
                                                        color: 'black',
                                                        name: i18n.TR('Gerät archivieren'),
                                                        show_me: canBeArchived && !deviceLocked,
                                                        action: function (view) {
                                                            var actionController = new DeviceActionController();
                                                            actionController.doArchive(id, view);
                                                        },
                                                    },
                                                ],
                                                show_me: hasAnyMenuOption,
                                            },
                                        ];
                                        AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                        App.showContentView(contentView, permissions);
                                    };

                                    var valuesReq = device.isValuesNeeded()
                                        ? App.request('device:values', device.id)
                                        : $.Deferred().resolve(undefined).promise();
                                    var firmwareInfoReq = App.request('device:firmwareUpdate', device.id);
                                    var contractNrReq =
                                        AppState.getContractNrList().length > 1
                                            ? App.request('device:contract:get', device.id)
                                            : null;
                                    var smartTempInfoReq =
                                        device.get('category') === Consts.Category.Controller
                                            ? App.request('device:smarttemp', id)
                                            : $.Deferred().resolve(new SmartTemp.SmartTempInfo()); // don't send request to backend

                                    $.when(valuesReq, firmwareInfoReq, smartTempInfoReq, contractNrReq).done(
                                        function (values, firmwareInfo, smartTempInfo, contractNrData) {
                                            if (device.isValuesNeeded()) {
                                                values = values === undefined ? undefined : values.toJSON();
                                                device.set('values', values);
                                            }

                                            if (contractNrData) {
                                                device.set('contractNr', contractNrData.contract_nr);
                                            }

                                            if (firmwareInfo === undefined) {
                                                // invalidate
                                                firmwareInfo = { updatePossible: false, isValid: false };
                                            } else {
                                                var job = firmwareInfo.job;
                                                var updatePossible = true;

                                                if (
                                                    firmwareInfo.available == '--' ||
                                                    ['RUNNING', 'WAITING', 'FINALIZING'].includes(job.state) ||
                                                    job.retry_count >= 5
                                                ) {
                                                    // update failed or is currently running/waiting
                                                    updatePossible = false;
                                                }
                                                firmwareInfo = _.extend(firmwareInfo, {
                                                    updatePossible: updatePossible,
                                                    isValid: true,
                                                });
                                            }

                                            device.set('firmwareInfo', firmwareInfo);

                                            device.set('smartTempInfo', smartTempInfo);
                                            showInfoView();
                                        }
                                    );

                                    return;
                                case 'info-management':
                                    var featuresReq = App.request('company:features');
                                    var miscInfoReq = App.request('miscinfo:model', id);
                                    AppState.requireColumns(function () {
                                        $.when(featuresReq, miscInfoReq).done(function (ff, miscInfo) {
                                            breadcrumbsView.options.target.title = i18n.TR('Verwaltung');
                                            contentView = new InfoManagementView({
                                                controller: self,
                                                features: ff,
                                                model: device,
                                                miscInfo: miscInfo,
                                            });
                                            AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                            App.showContentView(contentView, permissions);
                                        });
                                    });
                                    return;
                                // control-1 to control-3 are treated the same
                                case 'control-1':
                                    accessRight = Consts.Permissions.HandlingCircuit1;
                                case 'control-2':
                                    accessRight = accessRight ? accessRight : Consts.Permissions.HandlingCircuit2;
                                case 'control-3':
                                    accessRight = accessRight ? accessRight : Consts.Permissions.HandlingCircuit3;
                                case 'control-11':
                                    accessRight = accessRight ? accessRight : Consts.Permissions.HandlingCircuit11;
                                case 'control-12':
                                    accessRight = accessRight ? accessRight : Consts.Permissions.HandlingCircuit12;
                                case 'control-13':
                                    accessRight = accessRight ? accessRight : Consts.Permissions.HandlingCircuit13;
                                case 'control-water':
                                    accessRight = accessRight ? accessRight : Consts.Permissions.HandlingWater;
                                    var suffix = tab.split('-')[1];
                                    if (suffix == 'water') {
                                        suffix = '9';
                                    }
                                    suffix *= 10;
                                    breadcrumbsView.options.target.title = device.getCircuitNames()[tab];

                                    if (!Misc.isFirmwareSufficient(device.get('firmware'), '1.85')) {
                                        // firmware too old -> show hint
                                        contentView = new CommonViews.Message({
                                            title: i18n.TR('Hinweis'),
                                            text: i18n.TR(
                                                'Die Bedienung des Reglers erfordert eine Firmware Version >= 1.85.'
                                            ),
                                        });
                                        AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                        App.showContentView(contentView, permissions);
                                    } else {
                                        // query circuit infos
                                        var circuit = App.request(
                                            'circuit:model',
                                            device.id,
                                            parseInt(suffix),
                                            'handling'
                                        );
                                        var inconsistency = App.request('device:inconsistent', device);
                                        var smartTempInfoReq = App.request('device:smarttemp', id, true);

                                        $.when(circuit, inconsistency, smartTempInfoReq).done(
                                            function (circuit, inconsistent, smartTempInfo) {
                                                AppState.circuit = circuit;
                                                if (circuit === undefined) {
                                                    // could not load circuit-model
                                                    contentView = new CommonViews.Message({
                                                        title: i18n.TR('Fehler'),
                                                        text: i18n.TR('Einstellungen konnten nicht geladen werden.'),
                                                        color_class: 'box-color-error',
                                                        action_label: i18n.TR('Zurück zur Geräteinfo'),
                                                        action_cb: function () {
                                                            App.trigger(self.deviceCategory + ':show', id);
                                                        },
                                                    });
                                                } else {
                                                    contentView = new HandlingView({
                                                        model: circuit,
                                                        controller: self,
                                                        circuitNr: suffix,
                                                        inconsistent: inconsistent,
                                                        device: device,
                                                        smartTempInfo: smartTempInfo,
                                                    });
                                                }
                                                AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                                App.showContentView(contentView, permissions);
                                            }
                                        );

                                        breadcrumbsView.options.actions = [
                                            {
                                                icon: 'fa fa-cog',
                                                action: function () {
                                                    self.showHandlingSettingsDialog(device, tab, circuitName);
                                                },
                                                show_me:
                                                    AppState.hasDevicePermission(
                                                        accessRight,
                                                        permissions.attributes
                                                    ) === false,
                                            },
                                        ];
                                    }
                                    return;
                                case 'control-parameter':
                                    // get parent device
                                    var parentDevice = App.request('device:model', device.attributes.parent);
                                    // get configuration data for the controller
                                    var parameter = App.request(
                                        'device:get:parameter',
                                        id,
                                        Misc.isFirmwareSufficient(device.get('firmware'), '2.28')
                                    );
                                    var inconsistent = App.request('device:inconsistent', device);
                                    var smartTempInfoReq = App.request('device:smarttemp', device.id, true);
                                    // init breadcrumbs
                                    breadcrumbsView.options.target.title = i18n.TR('Parametrierung');
                                    AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                    $.when(parameter, parentDevice, inconsistent, smartTempInfoReq).done(
                                        function (parameter, parentDevice, inconsistent, smartTempInfo) {
                                            var failureText = i18n.TR('Das Laden der Daten ist fehlgeschlagen.');
                                            var messageColor = 'box-color-error';
                                            var messageTitle = i18n.TR('Fehler');
                                            if (parameter.data_points && parameter.circuits.length !== 0) {
                                                var forceReadonly = false;
                                                if (parentDevice) {
                                                    forceReadonly =
                                                        parentDevice.get('category') === 'Gateway-RF' &&
                                                        !Misc.isFirmwareSufficient(parentDevice.get('firmware'), '2.2');
                                                }

                                                App.showContentView(
                                                    new ParameterView({
                                                        deviceID: id,
                                                        device: device,
                                                        controller: self,
                                                        permissions: permissions,
                                                        parameter: parameter,
                                                        forceReadonly: forceReadonly,
                                                        inconsistent: inconsistent,
                                                        smartTempInfo: smartTempInfo,
                                                    })
                                                );
                                                return;
                                            } else {
                                                switch (parameter.error) {
                                                    case 'no_circuits_defined':
                                                        failureText = i18n.TR('Es wurden keine Heizkreise gefunden.');
                                                        break;
                                                    case 'no_modbus_values':
                                                        failureText = i18n.TR(
                                                            'Es konnten keine Daten vom Gerät gelesen werden.'
                                                        );
                                                        break;
                                                }
                                            }

                                            App.showContentView(
                                                new CommonViews.Message({
                                                    title: messageTitle,
                                                    text: failureText,
                                                    color_class: messageColor,
                                                    action_label: i18n.TR('Zurück zur Geräteinfo'),
                                                    action_cb: function () {
                                                        App.trigger(self.deviceCategory + ':show', id);
                                                    },
                                                })
                                            );
                                        }
                                    );
                                    return;

                                case 'admin-devices':
                                    self.showAdminSubDevicesView(device, breadcrumbsView, permissions);
                                    return;
                                case 'admin-user':
                                    // GET fetch all users and their permissions for this device
                                    var permissionList = App.request('device:permissions:authorized_users', id);
                                    $.when(permissionList).done(function (permissionList) {
                                        breadcrumbsView.options.target.title = i18n.TR('Nutzerverwaltung');
                                        if (permissionList === undefined) {
                                            // could not load permission list
                                            contentView = new CommonViews.Message({
                                                title: i18n.TR('Fehler'),
                                                text: i18n.TR('Die Nutzerliste konnte nicht geladen werden.'),
                                                color_class: 'box-color-error',
                                                action_label: i18n.TR('Zurück zur Geräteinfo'),
                                                action_cb: function () {
                                                    App.trigger(self.deviceCategory + ':show', id);
                                                },
                                            });
                                        } else {
                                            // show user administration view
                                            contentView = new UserAdminView({
                                                controller: self,
                                                device: device,
                                                collection: permissionList,
                                            });
                                        }
                                        AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                        App.showContentView(contentView, permissions);
                                    });
                                    return;
                                case 'admin-configuration':
                                    var valueList = App.request('device:values', id);
                                    var features = App.request('company:features');
                                    var smartTempInfoReq = App.request('device:smarttemp', id, true);

                                    $.when(valueList, features, smartTempInfoReq).done(
                                        function (valueList, features, smartTempInfo) {
                                            breadcrumbsView.options.target.title = i18n.TR('Konfiguration');
                                            if (valueList === undefined) {
                                                // could not load value list
                                                contentView = new CommonViews.Message({
                                                    title: i18n.TR('Fehler'),
                                                    text: i18n.TR('Es konnten keine Werte gefunden werden.'),
                                                    color_class: 'box-color-error',
                                                    action_label: i18n.TR('Zurück zur Geräteinfo'),
                                                    action_cb: function () {
                                                        App.trigger(self.deviceCategory + ':show', id);
                                                    },
                                                });
                                            } else {
                                                // show configuration view
                                                contentView = new ConfigurationView({
                                                    controller: self,
                                                    device: device,
                                                    collection: valueList,
                                                    permissions: permissions,
                                                    smartTempInfo: smartTempInfo,
                                                });

                                                var showSettings =
                                                    AppState.hasDevicePermission(
                                                        Consts.Permissions.Info,
                                                        permissions.attributes
                                                    ) === false;

                                                // default breadcrumb action: allow to configure basic device properties
                                                breadcrumbsView.options.actions = [
                                                    {
                                                        icon: 'fa fa-cog',
                                                        action: function () {
                                                            contentView.showDeviceSettings();
                                                        },
                                                        show_me: showSettings,
                                                    },
                                                ];

                                                // extended breadcrumb options for gateways?
                                                var extendedGatewayOptions = function () {
                                                    if (!AppState.hasCompanyDevicePermission()) {
                                                        return false;
                                                    }
                                                    if (
                                                        [Consts.Category.Gateway, Consts.Category.GatewayRF].includes(
                                                            device.get('category')
                                                        )
                                                    ) {
                                                        return true;
                                                    }
                                                    if (
                                                        device.get('category') == Consts.Category.Modbus &&
                                                        device.get('type') == '5022'
                                                    ) {
                                                        return true;
                                                    }
                                                    return false;
                                                };

                                                if (extendedGatewayOptions()) {
                                                    var showFirmwareConfig =
                                                        AppState.hasDevicePermission(
                                                            Consts.Permissions.AdminConfig,
                                                            permissions.attributes
                                                        ) === false;

                                                    var showRemoteUIConfig = showFirmwareConfig;
                                                    var baseURL = '/';
                                                    switch (device.get('category')) {
                                                        case Consts.Category.Gateway: {
                                                            baseURL = '-admin/';
                                                            showRemoteUIConfig =
                                                                AppState.user.get('is_admin') &&
                                                                device.get('type') == '5019' &&
                                                                Misc.isFirmwareSufficient(
                                                                    device.get('firmware'),
                                                                    '25.01'
                                                                );
                                                            break;
                                                        }
                                                        case Consts.Category.GatewayRF: {
                                                            baseURL = '/index.html';
                                                            showRemoteUIConfig =
                                                                device.get('type') == '5016' &&
                                                                Misc.isFirmwareSufficient(
                                                                    device.get('firmware'),
                                                                    '2.2'
                                                                );
                                                            break;
                                                        }
                                                        default: {
                                                            showRemoteUIConfig = false;
                                                            break;
                                                        }
                                                    }

                                                    var showGrantOnSiteAccess =
                                                        AppState.hasDevicePermission(
                                                            Consts.Permissions.AdminUser,
                                                            permissions.attributes
                                                        ) === false &&
                                                        AppState.hasDevicePermission(
                                                            Consts.Permissions.AdminConfig,
                                                            permissions.attributes
                                                        ) === false &&
                                                        features[Consts.Features.GrantOnsiteAccess] &&
                                                        (Misc.isFirmwareSufficient(device.get('firmware'), '1.90') ||
                                                            device.get('type') == '5018');

                                                    breadcrumbsView.options.actions = [
                                                        {
                                                            icon: 'fa fa-cog',
                                                            menu_items: [
                                                                {
                                                                    name: i18n.TR('Einstellungen'),
                                                                    show_me: showSettings,
                                                                    action: function () {
                                                                        contentView.showDeviceSettings();
                                                                    },
                                                                },
                                                                {
                                                                    name: i18n.TR('Firmware-Konfiguration'),
                                                                    show_me:
                                                                        showFirmwareConfig &&
                                                                        device.get('category') !=
                                                                            Consts.Category.GatewayRF,
                                                                    action: function () {
                                                                        FirmwareConfigView.show({
                                                                            controller: self,
                                                                            device: device,
                                                                        });
                                                                    },
                                                                },
                                                                {
                                                                    name: i18n.TR('Fernkonfiguration (Weboberfläche)'),
                                                                    show_me: showRemoteUIConfig,
                                                                    href:
                                                                        '/api/v1/devices/' +
                                                                        device.id +
                                                                        '/http-tunnel' +
                                                                        baseURL,
                                                                },
                                                                {
                                                                    name: i18n.TR('Freigabe für vor-Ort-Konfiguration'),
                                                                    show_me:
                                                                        showGrantOnSiteAccess &&
                                                                        device.get('category') ==
                                                                            Consts.Category.Gateway,
                                                                    action: function () {
                                                                        self.showOnsiteAccessConfirmationDialog(id);
                                                                    },
                                                                },
                                                            ],
                                                            show_me:
                                                                showSettings ||
                                                                showFirmwareConfig ||
                                                                showRemoteUIConfig ||
                                                                showGrantOnSiteAccess,
                                                        },
                                                    ];
                                                }

                                                // extended breadcrumb options for controller?
                                                var extendedControllerOptions = function () {
                                                    if (device.get('category') != Consts.Category.Controller) {
                                                        return false;
                                                    }
                                                    if (AppState.hasCompanyDevicePermission()) {
                                                        return true;
                                                    }
                                                    return false;
                                                };

                                                // gateways
                                                if (extendedControllerOptions()) {
                                                    var showBackup =
                                                        features[Consts.Features.ControllerBackup] &&
                                                        AppState.getDeviceInfo(device.get('parent')).category !==
                                                            'Gateway-RF';

                                                    var showFirmwareConfig =
                                                        AppState.hasDevicePermission(
                                                            Consts.Permissions.AdminConfig,
                                                            permissions.attributes
                                                        ) === false && device.get('wired_to') == device.id;

                                                    breadcrumbsView.options.actions = [
                                                        {
                                                            icon: 'fa fa-cog',
                                                            menu_items: [
                                                                {
                                                                    name: i18n.TR('Einstellungen'),
                                                                    action: function () {
                                                                        contentView.showDeviceSettings();
                                                                    },
                                                                    show_me: showSettings,
                                                                },
                                                                {
                                                                    name: i18n.TR('Firmware-Konfiguration'),
                                                                    action: function () {
                                                                        FirmwareConfigView.show({
                                                                            controller: self,
                                                                            device: device,
                                                                        });
                                                                    },
                                                                    show_me: showFirmwareConfig,
                                                                },
                                                                {
                                                                    name: i18n.TR('Regler-Backups'),
                                                                    action: function () {
                                                                        self.showControllerBackupDialog(
                                                                            device,
                                                                            !AppState.hasDevicePermission(
                                                                                Consts.Permissions.AdminConfig,
                                                                                permissions.attributes
                                                                            )
                                                                        );
                                                                    },
                                                                    show_me: showBackup,
                                                                },
                                                            ],
                                                            show_me: showSettings || showFirmwareConfig || showBackup,
                                                        },
                                                    ];
                                                }
                                            }
                                            AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                                            App.showContentView(contentView, permissions);
                                        }
                                    );
                                    return;
                                default:
                                    App.trigger('404');
                                    return;
                            }
                            AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                        }
                        App.showContentView(contentView, permissions);
                    });
                }
            },
        });
    },

    showContractDialog: function (params) {
        var contractNrList = AppState.getContractNrList();
        var listItem =
            Misc.selectWhereFirst(
                contractNrList,
                function (item) {
                    return item.nr == params.model.get('contractNr');
                },
                null
            ) || {};

        var view = new ContractDialogView({
            contractNrList: contractNrList,
            contractNrIdx: listItem.idx,
            save_cb: function (idx) {
                listItem =
                    Misc.selectWhereFirst(
                        contractNrList,
                        function (item) {
                            return item.idx == idx;
                        },
                        null
                    ) || {};
                const req = App.request('device:contract:set', params.model.id, listItem.nr);
                $.when(req).done(function (result) {
                    if (!result) {
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Die Vertragsnummer konnte nicht gespeichert werden.')
                        );
                        return;
                    }
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen wurden gespeichert.'));
                    params.model.set('contractNr', listItem.nr);
                    params.update_cb();
                });
            },
        });
        App.showModal(view);
    },

    showGroupingDialog: function (params) {
        // query all available labels - show as "tag cloud" to the user
        var allLabelsReq = App.request('filter:labels', { complete: true });
        var labelPoolReq = App.request('label:pool:list');

        $.when(allLabelsReq, labelPoolReq).done(function (allLabels, labelPool) {
            var srcData = {
                tags: params.models[0].get('tags'),
                groups: params.models[0].get('groups'),
                available: allLabels,
                labelPool: labelPool,
            };

            var view = new GroupingDialogView({
                labels: srcData,
                canEditTags: true,
                save_cb: function (data, onSuccess, onError) {
                    // build the difference map
                    var labels = { tags: {}, groups: {} };
                    _.each(['tags', 'groups'], function (grp) {
                        // build maps to get the differences
                        var origMap = {};
                        var newMap = {};

                        _.each(srcData[grp], function (item) {
                            origMap[item] = true;
                        });
                        _.each(data[grp], function (item) {
                            newMap[item] = true;
                            if (!origMap[item]) origMap[item] = false;
                        });

                        _.each(origMap, function (value, key) {
                            if (value != newMap[key]) {
                                if (grp != 'tags' || !data.labelPoolOnly || labelPool.includes(key)) {
                                    labels[grp][key] = !!newMap[key]; // want true or false
                                }
                            }
                        });
                    });

                    $.when(App.request('label:save', labels, _.map(params.models, 'id'))).done(function (result) {
                        if (!result) {
                            // write back to the models
                            _.each(params.models, function (m) {
                                m.set('tags', data.tags);
                                m.set('groups', data.groups);
                            });
                            onSuccess();
                            if (params.update_cb) {
                                params.update_cb();
                            }
                        } else onError(result, data);
                    });
                },
            });
            App.showModal(view);
        });
    },

    showConfigureValueDialog: function (params) {
        var dialog = new ConfigureValueDialogView({
            deviceID: params.deviceID,
            deviceCategory: params.deviceCategory,
            smartTempInfo: params.smartTempInfo,

            model: params.model,
            clone: params.clone,

            update_value_cb: function (update_params) {
                var model = update_params.model || new Values.Model({ device: params.deviceID });
                model.save(update_params.updated_model, {
                    success: function () {
                        update_params.success();
                        params.update_cb();
                    },
                    error: function (model, response) {
                        var errors = response.responseJSON || {
                            error: i18n.TR('Fehler beim Aktualisieren des Wertes.'),
                            sysErr: response.responseText || '',
                        };
                        update_params.error(errors);
                    },
                });
            },
        });
        App.showModal(dialog);
    },

    showSettingsDialog: function (device, callback) {
        var settingsView = App.DevicesCategoryObj[this.deviceCategory].settingsView;
        if (!settingsView) return;

        var view = new settingsView({
            controller: this,
            model: device,
            cb: callback,
            categoryKey: this.deviceCategory,
        });
        App.showModal(view);
    },

    showHandlingSettingsDialog: function (device, tab) {
        var view = new HandlingSettingsView({
            controller: this,
            model: device,
            cb: function (args) {
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
            formData: {
                tab: tab,
                defaultName: Consts.DefaultCircuitNames[tab],
                name: device.getCircuitNames()[tab],
            },
        });
        App.showModal(view);
    },

    showSelectValuesDialog: function (params) {
        if (params.fakeResponse) {
            var valSpecsMBR = true;
            var valSpecsMBC = true;
        } else {
            Decorator.disableElement('.content');
            var valSpecsMBR = App.request('device:valuespecs', 'MBR', params.group);
            var valSpecsMBC = App.request('device:valuespecs', 'MBC', params.group);
        }
        var smartTempInfoReq = App.request('device:smarttemp', params.deviceID, true);

        $.when(valSpecsMBR, valSpecsMBC, smartTempInfoReq).done(function (valSpecsMBR, valSpecsMBC, smartTempInfo) {
            Decorator.enableElement('.content');

            if (valSpecsMBR === undefined || valSpecsMBC === undefined) {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    i18n.TR('Werteinformationen konnten nicht geladen werden.')
                );
                return;
            }
            var options = {};
            if (valSpecsMBR === true) {
                options = params.fakeResponse;
            } else {
                options = [
                    { name: Consts.ValueTypes['MBR'], values: valSpecsMBR.toJSON() },
                    { name: Consts.ValueTypes['MBC'], values: valSpecsMBC.toJSON() },
                ];
            }
            var dialog = new SelectValuesDialogView({
                options: options,
                selectedValues: params.values,
                deviceID: params.deviceID,
                update_cb: params.update_cb,
                multi: params.multi,
                useCustomValues: params.useCustomValues,
                AllowedValueTypes: params.AllowedValueTypes,
                showUpdateClassDropdown: params.showUpdateClassDropdown,
                showUpdateClassInfo: params.showUpdateClassInfo,
                noValuesMessage: params.noValuesMessage,
                smartTemp: smartTempInfo,
            });
            App.showModal(dialog);
        });
    },

    showSelectHCsDialog: function (params) {
        var dialog = new SelectHCsDialogView(params);
        App.showModal(dialog);
    },

    showSmartTempDialog: function (params) {
        var dialog = new SmartTempDialogView(params);
        App.showModal(dialog);
    },

    showConfigureUserDialog: function (params) {
        // consistency check
        _.each(['devices', 'categories'], function (item) {
            if (params[item] === undefined) throw 'Missing params.' + item;
        });

        var dialog = new ConfigureUserDialogView({
            devices: params.devices,
            model: params.model,
            permission_base: params.permission_base,
            update_user_cb: function (update_params) {
                // multiple devices should be handled separately
                var model =
                    update_params.model ||
                    (params.devices.length > 1
                        ? new Permissions.DevicesModel({
                              devices: Misc.selectWhere(params.devices, undefined, function (item) {
                                  return item.id;
                              }),
                          })
                        : new Permissions.Model({ device: params.devices[0].id }));
                model.set('emails', update_params.emails);
                model.save(
                    {
                        name: update_params.email || model.get('name'),
                        access_rights: update_params.permissions,
                    },
                    {
                        // since the request can contain mutliple emailaddresses,
                        // even a successfull response can contain errors for some of these emails
                        success: function (model, errors) {
                            update_params.success(errors);
                            if (params.update_cb) {
                                params.update_cb();
                            }
                        },
                        error: function (model, response) {
                            update_params.error(response);
                        },
                    }
                );
            },
        });
        App.showModal(dialog);
    },

    showTransferUserPermissionsDialog: function (params) {
        var dialog = new UserTransferDialogView({
            model: params.device,
            transfer_cb: function (transfer_params) {
                App.ajax({
                    url: '/api/v1/devices/' + params.device.id + '/permissions/transfer',
                    type: 'POST',
                    data: {
                        email: transfer_params.email,
                    },
                    success: function () {
                        transfer_params.success();
                        params.update_cb();
                    },
                    error: function (xhr) {
                        var errors = xhr.responseJSON || {
                            error: i18n.TR('Fehler beim Übertragen der Zugriffsrechte.'),
                            sysErr: xhr.responseText || '',
                        };
                        transfer_params.error(errors);
                    },
                });
            },
        });
        App.showModal(dialog);
    },

    showMeterValueSelectionDialog: function (options) {
        app.showModal(new ValueSelectDialog(options));
    },

    showAdminSubDevicesView: function (device, breadcrumbsView, permissions) {
        var self = this;
        var itemsPerPage = AppState.getItemsPerPage();
        var filter = $.extend(AppState.getURLParameter(['sortCol', 'sortDesc', 'page']), {
            parentID: device.id,
            limit: itemsPerPage,
        });
        var deviceList = App.request('device:list', { filterParams: filter });

        $.when(deviceList).done(function (deviceList) {
            var contentView = undefined;

            if (deviceList === undefined) {
                // could not load sub-device list
                contentView = new CommonViews.Message({
                    title: i18n.TR('Fehler'),
                    text: i18n.TR('Die Liste der angeschlossenen Geräte konnte nicht geladen werden.'),
                    color_class: 'box-color-error',
                });
            } else {
                breadcrumbsView.options.target.title = i18n.TR('Angeschlossene Geräte');
                if (deviceList.count == 0) {
                    // no devices returned -> show placeholder
                    var viewOptions = {
                        title: i18n.TR('Keine Geräte gefunden'),
                        text: i18n.TR('Es wurden keine angeschlossenen Geräte gefunden.'),
                        titleID: 'no-devices-found',
                        readOnlyRight: Consts.Permissions.AdminDevices,
                    };

                    if (
                        AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices) &&
                        device.get('status') !== Consts.DeviceStatus.Archived
                    ) {
                        _.extend(viewOptions, {
                            action_label: i18n.TR('Gerät hinzufügen'),
                            action_label_2: i18n.TR('Automatische Erkennung'),
                            action_cb: function () {
                                DeviceController.addDevice({
                                    parent: device.id,
                                    type: 'passive',
                                    mode: 'fixedPassive',
                                    subDevices: self.getAddDeviceConfiguration(device).subDevices,
                                });
                            },
                            action_2_cb: function () {
                                DeviceController.detectSubDevices({
                                    controller: self,
                                    parentDevice: device,
                                });
                            },
                            id: device.id,
                        });
                    }

                    contentView = new CommonViews.Message(viewOptions);
                } else {
                    // show sub device list
                    contentView = new SubDeviceListView({
                        itemCount: deviceList.count,
                        itemsPerPage: itemsPerPage,
                        listResult: deviceList.listResult,

                        deviceCategory: null,
                        controller: self,
                        parentDevice: device,
                        collection: deviceList.items,
                        addDeviceConfig: self.getAddDeviceConfiguration(device),
                    });
                }
                AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
            }
            App.showContentView(contentView, permissions);
        });
    },

    showManagementDialogEdit: function (callback, groupId, model) {
        var view = new InfoManagementDialogView({
            controller: this,
            model: model,
            callback: callback,
            groupId: groupId,
        });
        App.showModal(view);
    },

    reInitializeDevice: function (params) {
        Decorator.disableElement('.content');
        var self = this;

        // assemble URL + prepare notification messages
        var url = '/api/v1/devices/' + params.id + '/reinitialize';
        var successMessage = i18n.TR('Geräteinfos wurden aktualisiert.');
        var errorMessage = i18n.TR('Geräteinfos konnten nicht aktualisiert werden.') + '<br>';

        // schema initialization? -> adapt
        if (params.schema_init) {
            url += '?schema=true';

            successMessage = i18n.TR('Konfiguration wurden aktualisiert.');
            errorMessage = i18n.TR('Konfiguration konnte nicht aktualisiert werden.') + '<br>';
        }

        App.ajax({
            url: url,
            type: 'POST',
            data: {},
            success: function (updatedModel) {
                Decorator.enableElement('.content');
                params.update_cb(updatedModel);
                Notification.show('success', i18n.TR('Erfolg'), successMessage);
            },
            error: function (xhr) {
                Decorator.enableElement('.content');
                var errors = xhr.responseJSON || { error: xhr.responseText };
                Notification.show('error', i18n.TR('Fehler'), errorMessage + i18n.TR(errors.error));
            },
        });
    },

    updateModel: function (params) {
        params.model.save(params.updated_model, {
            success: function (model, resp) {
                params.success(model, resp);
            },
            error: function (model, response) {
                var errors = response.responseJSON || {
                    error: i18n.TR('Fehler beim Aktualisieren des Gerätes.'),
                    sysErr: response.responseText || '',
                };
                params.error(errors);
            },
        });
    },

    createModel: function (params) {
        params.model.save(
            {},
            {
                success: function (model) {
                    params.success(model);
                },
                error: function (model, response) {
                    var errors = response.responseJSON || {
                        error: i18n.TR('Fehler beim Hinzufügen des Gerätes.'),
                        sysErr: Misc.getDeviceErrorText(response.responseText) || '',
                    };
                    params.error(errors);
                },
            }
        );
    },

    getAddDeviceConfiguration: function (device) {
        var catData = Consts.DeviceCategory[this.deviceCategory];
        var self = this;

        var subDevices = [];
        _.each(Consts.DeviceCategory, function (data, category) {
            if (data.connectsTo && data.connectsTo.indexOf(self.deviceCategory) >= 0) {
                subDevices.push(Consts.Category[category]);
            }
        });

        var result = undefined;

        if (device) {
            // device available -> add sub device
            result = {
                parent: device.id,
                type: 'passive',
                mode: 'fixedPassive',
                subDevices: subDevices,
            };
        } else {
            // add new controller
            result = {
                type: catData.connectActive ? 'active' : 'passive',
                category: Consts.Category[this.deviceCategory],
            };
        }

        return result;
    },

    getRegisters: function (registerMap, nonPollingValues, callback) {
        var req = App.request('devices:registers', registerMap, nonPollingValues);
        $.when(req).done(function (rm) {
            callback(rm);
        });
    },

    createAlarm: function (devices) {
        var c = new AlarmController();
        c.createAlarmForDevices(devices);
    },

    invite: function (list) {
        var self = this;
        var deviceList = Misc.selectWhere(list, undefined, function (item) {
            return item.id;
        });

        if (list.length == 0) return;

        // get all capabilities
        var capabilities = undefined;
        _.each(list, function (device) {
            if (capabilities === undefined) {
                capabilities = device.get('capabilities');
                return;
            }
            capabilities = _.intersection(capabilities, device.get('capabilities'));
        });

        var categories = Misc.selectWhere(
            list,
            undefined,
            function (item) {
                return item.get('category');
            },
            true
        );

        // get the user rights intersection of all those devices
        var permissionList = App.request('device:permissions:shared', deviceList);
        $.when(permissionList).done(function (permissionList) {
            if (!permissionList) {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Benutzerrechte können nicht gelesen werden.'));

                return; // TODO: error handling
            }

            self.showConfigureUserDialog({
                devices: list,
                permission_base: permissionList,
                capabilities: capabilities,
                categories: categories,
            });
        });
    },

    checkConsistency: function () {
        var self = this;
        // deviceCategory must be defined and consistent with Consts.DeviceCategory, Consts.Category and Consts.DeviceType
        var categoryKey = Consts.DeviceCategory[this.deviceCategory].categoryKey;

        if (!this.deviceCategory) throw 'Category must be defined';
        if (!Consts.DeviceCategory[this.deviceCategory])
            throw 'Category ' + this.deviceCategory + '  must be defined in Consts.DeviceCategory';
        if (!Consts.DeviceCategory[this.deviceCategory])
            throw 'Category ' + this.deviceCategory + '  must be defined in Consts.Category';
        if (!App.DevicesCategoryObj[this.deviceCategory])
            throw 'Category ' + this.deviceCategory + ' must be defined in App.DevicesCategoryObj';

        var deviceCategoryObj = App.DevicesCategoryObj[this.deviceCategory];
        _.each(['controller', 'settingsView', 'listView'], function (key) {
            if (deviceCategoryObj[key] === undefined) {
                throw 'Category ' + self.deviceCategory + ' / ' + key + ' must be defined in App.DevicesCategoryObj';
            }
        });

        // listView must be defined
        if (!this.listView) throw 'ListView must be defined';
    },

    showControllerBackupDialog: function (device, fullAccess) {
        // TODO: forward "fullAccess" to dialog
        //
        var req = App.request('devices:backups', device.get('type'));
        var self = this;
        $.when(req)
            .done(function (backupFiles) {
                App.showModal(
                    new ControllerBackupDialogView({
                        device: device.id,
                        type: device.get('type'),
                        controller: self,
                        files: backupFiles,
                    })
                );
            })
            .fail(function () {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Backup-Dateien konnten nicht geladen werden'));
            });
    },

    showEditValueDialog: function (model, device, writeInfo) {
        var deviceID = device.get('id');
        var categoryID = device.get('category');
        if (!categoryID.startsWith('55xx56xx')) {
            categoryID += '/' + device.get('type');
        }

        // initialize requests ..
        var requests = [App.request('company:features'), this.getTargetOfflineValues(device)];

        // .. add remote value transfer requests
        if (model.get('transfer_mode') != Consts.TransferMode.None) {
            requests.push(App.request('device:remote_value_transfer', model.getAddress(), deviceID, model));
            requests = _.union(requests, this.requestValuesForDevices({}, categoryID, [device.id]));
        }

        var self = this;
        $.when.apply($, requests).done(
            function (
                companyFeatures,
                fallbackInfo,
                rvtInfo,
                registers,
                coils,
                _input, // read-only
                _discrete, // read-only
                selected
            ) {
                rvtInfo = rvtInfo || { rvt: undefined };
                if (rvtInfo.success === false) {
                    Notification.show(rvtInfo.type, rvtInfo.header, rvtInfo.message);
                    return;
                }
                var canAccessWeatherData = false;
                if (companyFeatures && companyFeatures.extended_value_transfer) {
                    var canAccessWeatherData = companyFeatures.extended_value_transfer.values == 'weather_data';
                }

                App.showModal(
                    new DataEditDialogView.Dialog({
                        model: model,
                        rvt: rvtInfo.rvt,
                        device: device,
                        controller: self,
                        writeInfo: writeInfo,
                        canAccessWeatherData: canAccessWeatherData,
                        fallbackResponse: fallbackInfo,
                        registers: registers,
                        coils: coils,
                        selected: selected,
                    })
                );
            }
        );
    },

    saveRemoteValueTransfer: function (rvt) {
        return rvt.save(
            {},
            {
                success: function (_model, response) {
                    return response;
                },
                error: function (_model, response) {
                    return 'rvt_failed';
                },
            }
        );
    },

    getFallbackURL: function (device) {
        return '/api/v1/devices/' + device.get('id') + '/fallbackvalues/' + device.get('station');
    },

    writeTargetOfflineValues: function (targetOfflineValues, device) {
        var def = $.Deferred();

        if (!targetOfflineValues.changed) {
            return def.resolve().promise();
        }

        App.ajax({
            method: 'PUT',
            url: this.getFallbackURL(device),
            data: JSON.stringify(targetOfflineValues),
            success: function (response) {
                def.resolve(response);
            },
            error: function (_response) {
                def.reject('fallbackvalues_failed');
            },
        });
        return def.promise();
    },

    getTargetOfflineValues: function (device) {
        var def = $.Deferred();
        App.ajax({
            method: 'GET',
            url: this.getFallbackURL(device),
            success: function (response) {
                def.resolve({
                    success: true,
                    hasAccess: response.has_access,
                    config: response.config,
                    disablingReason: response.has_access
                        ? ''
                        : i18n.TR(
                              'Für die Konfiguration von Rückfallwerten sind Schreibrechte für das Gateway erforderlich.'
                          ),
                });
            },
            error: function (response) {
                var disablingReason = '';
                switch (response.responseJSON) {
                    case 'fallback_values_not_supported':
                        disablingReason = '';
                        break;
                    case 'firmware_not_sufficient':
                        disablingReason = i18n.TR(
                            'Um Rückfallwerte konfigurieren zu können, ist ein Gateway Firmware Update erforderlich.'
                        );
                        break;
                    default:
                        disablingReason = i18n.TR('Fehler beim Laden der Rückfallwerte.');
                }
                def.resolve({
                    success: false,
                    disablingReason: disablingReason,
                });
            },
        });
        return def.promise();
    },

    saveValue: function (mbValue, cb) {
        mbValue.save(
            {},
            {
                success: function () {
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Wert wurde geschrieben.'));
                    if (cb) {
                        cb();
                    } else {
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    }
                },
                error: function (errors) {
                    Decorator.enableElement('.modal-dialog');
                    App.hideModal();
                    Notification.show('error', i18n.TR('Fehler'), i18n.TR('Wert konnte nicht geschrieben werden.'));
                },
            }
        );
    },

    createBatchWriteJob: function (batchWriteRequest) {
        var def = $.Deferred();
        var request = batchWriteRequest;

        batchWriteRequest.save(
            {},
            {
                type: 'POST',
                success: function (self, resp) {
                    request.jobID = resp.jobID;
                    def.resolve();
                },
                error: function (errors) {
                    Decorator.enableElement('.modal-dialog');
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Übertragung konnte nicht gestartet werden.')
                    );
                    def.reject();
                },
            }
        );
        return def.promise();
    },

    cancelBatchWriteJob: function (jobID) {
        var def = $.Deferred();
        App.ajax({
            method: 'DELETE',
            url: '/api/v1/jobs/' + jobID,
            success: function (data) {
                def.resolve();
            },
            error: function (data) {
                def.reject();
            },
        });
        return def.promise();
    },

    closeBatchWriteDialog: function (jobID) {
        var self = this;
        Utils.showConfirmationDialog({
            title: i18n.TR('Fenster schließen'),
            hint: i18n.TR('Der Schreibvorgang wird im Hintergrund fortgesetzt.'),
            action_label: i18n.TR('Schreibvorgang abbrechen'),
            cancel_label: i18n.TR('OK'),

            action_cb: function () {
                var req = self.cancelBatchWriteJob(jobID);
                $.when(req)
                    .then(function () {
                        Notification.show('warning', i18n.TR('Warnung'), i18n.TR('Schreibvorgang wird abgebrochen'));
                    })
                    .fail(function () {
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Schreibvorgang konnte nicht abgebrochen werden')
                        );
                    });
            },
        });
    },

    getUploadConfiguration: function (registerMap, callback) {
        var req = App.request('register:configuration', registerMap);
        $.when(req).done(function (valueConfiguration) {
            callback(valueConfiguration);
        });
    },

    getUniqueSelectedTypes: function (view, devices, valueFilter) {
        var deviceGroups = { groups: {}, groupCount: 0 };

        for (var key in devices) {
            var tmpGroup = devices[key].getGroupFilter(true);
            // special treatment for controllers - don't differentiate between different types
            if (tmpGroup.startsWith('55xx56xx')) {
                tmpGroup = '55xx56xx';
            }
            var tmpId = devices[key].get('id');

            if (deviceGroups.groups[tmpGroup]) {
                deviceGroups.groups[tmpGroup].deviceCount++;
                deviceGroups.groups[tmpGroup].devices.push(tmpId);
            } else {
                var parts = tmpGroup.split('/');
                deviceGroups.groups[tmpGroup] = {
                    deviceCount: 1,
                    name: tmpGroup,
                    category: parts[0],
                    type: parts[1] || '',
                };
                deviceGroups.groups[tmpGroup].devices = [tmpId];
                deviceGroups.groupCount++;
            }
        }

        view.deviceGroups = deviceGroups;

        if (deviceGroups.groupCount == 1) {
            // auto select the group by default
            view.selectedCategoryID = tmpGroup;
            view.total = deviceGroups.groups[tmpGroup].deviceCount;
            this.requestValues(view, valueFilter);
        }
    },

    requestValues: function (view, valueFilter) {
        function initValuespecs(regs, coils, input, discrete, selected) {
            // this is assumed to be set to the view!
            view.selectedValues = selected;
            if (regs === undefined && coils === undefined) {
                view.values = undefined;
            } else {
                view.values = {
                    Coils: coils,
                    Registers: regs,
                    Input: input,
                    Discrete: discrete,
                };
            }
            view.render();
        }

        $.when
            .apply(
                $,
                this.requestValuesForDevices(
                    valueFilter,
                    view.selectedCategoryID,
                    view.deviceGroups.groups[view.selectedCategoryID].devices
                )
            )
            .done(initValuespecs);
    },

    requestValuesForDevices: function (valueFilter, categoryID, deviceIDs) {
        var regReq = App.request('device:valuespecs', 'MBR', categoryID, valueFilter);
        var coilReq = App.request('device:valuespecs', 'MBC', categoryID, valueFilter);

        var inputReq = undefined;
        var discreteReq = undefined;
        if (categoryID.startsWith('GenericModbus')) {
            inputReq = App.request('device:valuespecs', 'MBI', categoryID, valueFilter);
            discreteReq = App.request('device:valuespecs', 'MBD', categoryID, valueFilter);
        }

        var selectedValues = App.request('devices:values', deviceIDs);

        return [regReq, coilReq, inputReq, discreteReq, selectedValues];
    },

    showOnsiteAccessConfirmationDialog: function (deviceID) {
        var view = new OnsiteAccessWizardView({
            deviceID: deviceID,
        });
        App.showModal(view);
    },

    createBackupJob: function (backupReq) {
        var def = $.Deferred();
        backupReq.save(
            {},
            {
                type: 'POST',
                success: function (self, resp) {
                    def.resolve(resp);
                },
                error: function (errors) {
                    Decorator.enableElement('.modal-dialog');
                    Notification.show('error', i18n.TR('Fehler'), i18n.TR('Vorgang konnte nicht gestartet werden.'));
                    def.reject();
                },
            }
        );
        return def.promise();
    },

    initTabs: function (device, permissions, trovisIOInfos, schemaJSONResp) {
        var type = device.get('type');
        var id = device.id;
        var schema = device.get('schema') || '';
        var tabs = [{ name: i18n.TR('Hauptschema'), urls: Requests.getSchemaURLs(id, type, schema), circuitID: 0 }];

        if (schemaJSONResp) {
            tabs = _.union(tabs, schemaJSONResp.schemas);
        }
        if ($.isEmptyObject(trovisIOInfos)) {
            return tabs;
        }

        var circuitToPermission = {
            11: Consts.Permissions.HandlingCircuit11 + '',
            12: Consts.Permissions.HandlingCircuit12 + '',
            13: Consts.Permissions.HandlingCircuit13 + '',
        };

        var circuitNames = device.getCircuitNames();
        // identify additional circuits
        _.each(
            trovisIOInfos,
            function (circuitInfo, circuitID) {
                if (_.contains(_.keys(permissions.attributes), circuitToPermission[circuitID])) {
                    var url = '/api/v1/devices/' + device.id + '/scheme/';
                    url += circuitInfo.schema_type
                        ? circuitInfo.schema_type + '.svg'
                        : '1.0-trovisio-' + circuitID + '.svg';

                    tabs.push({
                        name: circuitNames['control-' + circuitID],
                        urls: [url],
                        circuitID: parseInt(circuitID * 10),
                    });
                }
            },
            this
        );

        return tabs;
    },
});

module.exports = BaseDeviceController;
